

const defaults = {
	library: 'socket.io',
	status: 'offline',
	chatroomId: 0,
	networkDelay: 0
};


export default (state=defaults, action) => {
	switch(action.type){
		case 'CHATROOM_CONNECT':{
			return {...state, 
				status: 'connect', 
				networkDelay: 0,
				chatroomId: action.payload.chatroomId
			};
		}
		case 'CHATROOM_SET_STATUS':{
			return {...state, 
				status: action.payload
			};
		}
		case 'CHATROOM_SET_DELAY': 
			return {...state,
				networkDelay: action.payload.networkDelay
			}
		case 'PAGE_INIT':
			return {...state, status: 'offline'};
		default:
			return state;
	}
}





// WEBPACK FOOTER //
// ./src/reducers/chatroom.js